import { Box, Divider, Typography } from '@mui/material'
import React from 'react'

export const OrComponent = () => {
    return (
        <Box
            display={'flex'}
            flexDirection={'row'}
            justifyContent={'center'}
            alignItems={'center'}
            sx={{
                width: '100%',
            }}
        >
            <Divider sx={{ width: '40%', borderColor: 'var(--border)' }} />
            <Typography variant={'subtitle1'} sx={{ fontSize: '0.72rem', fontWeight: 600, letterSpacing: '0.08em', color: 'var(--muted-foreground)', margin: '0 12px' }}>
                O
            </Typography>
            <Divider sx={{ width: '40%', borderColor: 'var(--border)' }} />
        </Box>
    )
}
